import React from "react";
import { toast } from "react-toastify";
import CaNotification, { CaNotificationProps } from "../admin-panel/notifications/CaNotification";

export type NotifyArgs = {
  intent?: CaNotificationProps["intent"];
  title?: CaNotificationProps["title"];
  description: CaNotificationProps["description"];
};

export function notify({ intent, title, description }: NotifyArgs) {
  toast(({ closeToast }) => (
    <CaNotification
      intent={intent}
      title={title}
      description={description}
      closeToast={closeToast}
    />
  ));
}
